import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { ShFormCheckboxBaseComponent } from '../base-simple/form-checkbox-base.component';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormCheckboxComplexBaseComponent } from '../base-complex/form-checkbox-complex-base.component';
import { ShActionItemComponent } from '../../../../elements/components/action-item/action-item.component';
import { AsyncPipe, NgClass, NgTemplateOutlet } from '@angular/common';
import { ShFormLabelComponent } from '../../_core/form-label/form-label.component';

@Component({
    selector: 'sh-form-checkbox',
    templateUrl: './form-checkbox.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
    ShFormLabelComponent,
    NgTemplateOutlet,
    ShActionItemComponent,
    ShFormCheckboxComplexBaseComponent,
    ReactiveFormsModule,
    NgClass,
    ShFormCheckboxBaseComponent,
    AsyncPipe
]
})
export class ShFormCheckboxComponent extends ShBaseFormComponent {
    @Input() hideInnerLabel: boolean = false;
}
